/* Dante Furniture — Bespoke bed PDP behaviour
   - Colour swatches: update selected-name label
   - Storage image cards: drive the hidden native variant option
   - Service add-ons: modal + add checked add-on products to the basket
     after the main product is added (listens to the theme's on:cart:add)
*/
(function () {
  'use strict';

  /* ---- Fabric / colour picker (trigger row + drawer) ---- */
  function initSwatches() {
    document.querySelectorAll('[data-df-fabric]').forEach(function (group) {
      if (group.dataset.dfInit) return;
      group.dataset.dfInit = '1';

      var nameEl = group.querySelector('[data-df-fabric-name]');
      var discEl = group.querySelector('[data-df-fabric-disc]');
      var footName = group.querySelector('[data-df-fabric-foot-name]');
      var footDisc = group.querySelector('[data-df-fabric-foot-disc]');
      var drawer = group.querySelector('[data-df-fabric-drawer]');
      var overlay = group.querySelector('[data-df-fabric-overlay]');
      var openBtn = group.querySelector('[data-df-fabric-open]');
      var xBtn = group.querySelector('[data-df-fabric-x]');
      var confirmBtn = group.querySelector('[data-df-fabric-confirm]');

      function update() {
        var sel = group.querySelector('.df-swatch__input:checked');
        group.querySelectorAll('.df-swatch').forEach(function (l) {
          var input = l.querySelector('.df-swatch__input');
          l.classList.toggle('is-selected', !!(input && input.checked));
        });
        if (!sel) return;
        var disc = sel.closest('.df-swatch').querySelector('.df-swatch__disc');
        var style = disc ? disc.getAttribute('style') || '' : '';
        if (nameEl) nameEl.textContent = sel.value;
        if (footName) footName.textContent = sel.value;
        if (discEl) discEl.setAttribute('style', style);
        if (footDisc) footDisc.setAttribute('style', style);
      }

      function openDrawer() {
        if (!drawer) return;
        drawer.hidden = false;
        if (overlay) overlay.hidden = false;
        document.body.classList.add('df-addon-modal-open');
      }
      function closeDrawer() {
        if (!drawer) return;
        drawer.hidden = true;
        if (overlay) overlay.hidden = true;
        document.body.classList.remove('df-addon-modal-open');
      }

      if (openBtn) openBtn.addEventListener('click', openDrawer);
      if (xBtn) xBtn.addEventListener('click', closeDrawer);
      if (confirmBtn) confirmBtn.addEventListener('click', closeDrawer);
      if (overlay) overlay.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDrawer();
      });

      group.addEventListener('change', update);
      update();
    });
  }

  /* ---- Fabric library (trigger row + drawer with tabs + swatch grid) ---- */
  function initFabricLibrary() {
    document.querySelectorAll('[data-df-flib]').forEach(function (group) {
      if (group.dataset.dfInit) return;
      group.dataset.dfInit = '1';

      var selectedEl = group.querySelector('[data-df-flib-selected]');
      var discEl = group.querySelector('[data-df-flib-disc]');
      var footName = group.querySelector('[data-df-flib-foot-name]');
      var footDisc = group.querySelector('[data-df-flib-foot-disc]');
      var drawer = group.querySelector('[data-df-flib-drawer]');
      var overlay = group.querySelector('[data-df-flib-overlay]');
      var openBtn = group.querySelector('[data-df-flib-open]');
      var xBtn = group.querySelector('[data-df-flib-x]');
      var confirmBtn = group.querySelector('[data-df-flib-confirm]');

      function update() {
        var sel = group.querySelector('.df-flib__input:checked');
        group.querySelectorAll('.df-flib__swatch').forEach(function (l) {
          var input = l.querySelector('.df-flib__input');
          l.classList.toggle('is-selected', !!(input && input.checked));
        });
        if (!sel) return;
        var img = sel.closest('.df-flib__swatch').querySelector('.df-flib__img');
        var style = img ? img.getAttribute('style') || '' : '';
        if (selectedEl) selectedEl.textContent = sel.value;
        if (footName) footName.textContent = sel.value;
        if (discEl) discEl.setAttribute('style', style);
        if (footDisc) footDisc.setAttribute('style', style);
      }

      function openDrawer() {
        if (!drawer) return;
        drawer.hidden = false;
        if (overlay) overlay.hidden = false;
        document.body.classList.add('df-addon-modal-open');
      }
      function closeDrawer() {
        if (!drawer) return;
        drawer.hidden = true;
        if (overlay) overlay.hidden = true;
        document.body.classList.remove('df-addon-modal-open');
      }

      if (openBtn) openBtn.addEventListener('click', openDrawer);
      if (xBtn) xBtn.addEventListener('click', closeDrawer);
      if (confirmBtn) confirmBtn.addEventListener('click', closeDrawer);
      if (overlay) overlay.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDrawer();
      });

      group.querySelectorAll('[data-df-flib-tab]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var idx = tab.dataset.dfFlibTab;
          group.querySelectorAll('[data-df-flib-tab]').forEach(function (t) {
            t.classList.toggle('is-active', t === tab);
          });
          group.querySelectorAll('[data-df-flib-panel]').forEach(function (p) {
            p.classList.toggle('is-active', p.dataset.dfFlibPanel === idx);
          });
        });
      });

      group.addEventListener('change', update);
      update();
    });
  }

  /* ---- Size picker drawer ---- */
  function initSize() {
    document.querySelectorAll('[data-df-size]').forEach(function (group) {
      if (group.dataset.dfInit) return;
      group.dataset.dfInit = '1';

      var optionName = group.dataset.dfSizeOption || 'Size';
      var scope = group.closest('product-form') || document;

      // The theme re-renders the variant picker on variant change, replacing
      // the fieldset element — always re-query instead of caching it.
      function getFieldset() {
        var found = null;
        scope.querySelectorAll('.option-selector').forEach(function (fs) {
          if ((fs.dataset.option || '') === optionName) found = fs;
        });
        return found;
      }

      if (!getFieldset()) {
        group.style.display = 'none';
        return;
      }

      var nameEl = group.querySelector('[data-df-size-name]');
      var drawer = group.querySelector('[data-df-size-drawer]');
      var overlay = group.querySelector('[data-df-size-overlay]');
      var openBtn = group.querySelector('[data-df-size-open]');
      var xBtn = group.querySelector('[data-df-size-x]');

      function radios() {
        var fs = getFieldset();
        return fs ? fs.querySelectorAll('input.js-option') : [];
      }

      function update() {
        var fs = getFieldset();
        var checked = fs ? fs.querySelector('input.js-option:checked') : null;
        var val = checked ? checked.value : '';
        if (nameEl) nameEl.textContent = val;
        group.querySelectorAll('[data-df-size-value]').forEach(function (row) {
          row.classList.toggle('is-selected', row.dataset.dfSizeValue === val);
        });
      }
      function updateSoon() {
        setTimeout(update, 0);
      }

      function openDrawer() {
        drawer.hidden = false;
        if (overlay) overlay.hidden = false;
        document.body.classList.add('df-addon-modal-open');
      }
      function closeDrawer() {
        drawer.hidden = true;
        if (overlay) overlay.hidden = true;
        document.body.classList.remove('df-addon-modal-open');
      }

      if (openBtn) openBtn.addEventListener('click', openDrawer);
      if (xBtn) xBtn.addEventListener('click', closeDrawer);
      if (overlay) overlay.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDrawer();
      });

      group.querySelectorAll('[data-df-size-value]').forEach(function (row) {
        // Hide rows for sizes this product doesn't have (defensive)
        var exists = false;
        radios().forEach(function (r) {
          if (r.value === row.dataset.dfSizeValue) exists = true;
        });
        if (!exists) {
          row.style.display = 'none';
          return;
        }

        row.addEventListener('click', function () {
          var target = null;
          radios().forEach(function (r) {
            if (r.value === row.dataset.dfSizeValue) target = r;
          });
          if (target && !target.checked) {
            target.checked = true;
            target.dispatchEvent(new Event('change', { bubbles: true }));
          }
          updateSoon();
          closeDrawer();
        });
      });

      // Delegated: survives the theme replacing the fieldset on re-render
      scope.addEventListener('change', function (e) {
        if (e.target && e.target.classList && e.target.classList.contains('js-option')) updateSoon();
      });
      document.addEventListener('on:variant:change', updateSoon);
      update();
    });
  }

  /* ---- Storage image cards ---- */
  function initStorage() {
    document.querySelectorAll('[data-df-storage]').forEach(function (group) {
      if (group.dataset.dfInit) return;
      group.dataset.dfInit = '1';

      var optionName = group.dataset.dfStorageOption || 'Storage Option';
      var scope = group.closest('product-form') || document;

      // The theme re-renders the variant picker on variant change, replacing
      // the fieldset element — always re-query instead of caching it.
      function getFieldset() {
        var found = null;
        scope.querySelectorAll('.option-selector').forEach(function (fs) {
          if ((fs.dataset.option || '') === optionName) found = fs;
        });
        return found;
      }

      if (!getFieldset()) {
        // Product has no matching option — hide the picker entirely.
        group.style.display = 'none';
        return;
      }

      var nameEls = group.querySelectorAll('[data-df-storage-name]');
      var drawer = group.querySelector('[data-df-storage-drawer]');
      var overlay = group.querySelector('[data-df-storage-overlay]');
      var openBtn = group.querySelector('[data-df-storage-open]');
      var xBtn = group.querySelector('[data-df-storage-x]');
      var doneBtn = group.querySelector('[data-df-storage-done]');

      // Variant data for per-card price differences
      var vdata = null;
      try {
        var dataEl = group.querySelector('[data-df-storage-data]');
        if (dataEl) vdata = JSON.parse(dataEl.textContent);
      } catch (e) { /* price deltas just won't show */ }

      function radios() {
        var fs = getFieldset();
        return fs ? fs.querySelectorAll('input.js-option') : [];
      }

      // Currently selected value for each option position (1-based)
      function currentSelections() {
        var sel = {};
        scope.querySelectorAll('.option-selector').forEach(function (fs) {
          var idx = parseInt(fs.dataset.index, 10);
          var checked = fs.querySelector('input.js-option:checked');
          if (idx && checked) sel[idx] = checked.value;
        });
        return sel;
      }

      // Price of the variant matching current selections but with the given storage value
      function priceFor(storageValue, selections) {
        if (!vdata) return null;
        var found = null;
        vdata.variants.forEach(function (v) {
          if (found) return;
          var ok = true;
          for (var i = 1; i <= 3; i++) {
            var want = i === vdata.optionIndex ? storageValue : selections[i];
            if (want == null) continue;
            if (v['option' + i] !== want) ok = false;
          }
          if (ok) found = v;
        });
        return found ? found.price : null;
      }

      function update() {
        var fs = getFieldset();
        var checked = fs ? fs.querySelector('input.js-option:checked') : null;
        var val = checked ? checked.value : '';
        var selectedLabel = val;

        // Compute price deltas vs the cheapest base for the current selection
        var selections = currentSelections();
        var prices = {};
        var base = null;
        group.querySelectorAll('[data-df-storage-value]').forEach(function (card) {
          if (card.style.display === 'none') return;
          var p = priceFor(card.dataset.dfStorageValue, selections);
          prices[card.dataset.dfStorageValue] = p;
          if (p !== null && (base === null || p < base)) base = p;
        });

        group.querySelectorAll('[data-df-storage-value]').forEach(function (card) {
          var isSelected = card.dataset.dfStorageValue === val;
          card.classList.toggle('is-selected', isSelected);
          if (isSelected) {
            var labelEl = card.querySelector('.df-storage__value');
            if (labelEl) selectedLabel = labelEl.textContent.trim();
          }
          // Grey out combinations unavailable for the current selection
          // (e.g. a size that has no 4 Drawer base)
          var radio = null;
          radios().forEach(function (r) {
            if (r.value === card.dataset.dfStorageValue) radio = r;
          });
          if (radio) {
            card.classList.toggle('is-unavailable', radio.classList.contains('is-unavailable'));
          }
          // Price difference label, e.g. "+ £60.00"
          var priceEl = card.querySelector('[data-df-storage-price]');
          if (priceEl) {
            var p = prices[card.dataset.dfStorageValue];
            if (p !== null && p !== undefined && base !== null && p - base > 0) {
              priceEl.textContent = '+ £' + ((p - base) / 100).toFixed(2);
            } else {
              priceEl.textContent = '';
            }
          }
        });
        nameEls.forEach(function (el) {
          el.textContent = selectedLabel;
        });
      }
      function updateSoon() {
        setTimeout(update, 0);
      }

      function openDrawer() {
        if (!drawer) return;
        drawer.hidden = false;
        if (overlay) overlay.hidden = false;
        document.body.classList.add('df-addon-modal-open');
      }
      function closeDrawer() {
        if (!drawer) return;
        drawer.hidden = true;
        if (overlay) overlay.hidden = true;
        document.body.classList.remove('df-addon-modal-open');
      }

      if (openBtn) openBtn.addEventListener('click', openDrawer);
      if (xBtn) xBtn.addEventListener('click', closeDrawer);
      if (doneBtn) doneBtn.addEventListener('click', closeDrawer);
      if (overlay) overlay.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDrawer();
      });

      group.querySelectorAll('[data-df-storage-value]').forEach(function (card) {
        // Hide cards whose value doesn't exist on this product
        var exists = false;
        radios().forEach(function (r) {
          if (r.value === card.dataset.dfStorageValue) exists = true;
        });
        if (!exists) {
          card.style.display = 'none';
          return;
        }

        card.addEventListener('click', function () {
          var target = null;
          radios().forEach(function (r) {
            if (r.value === card.dataset.dfStorageValue) target = r;
          });
          if (target && !target.checked) {
            target.checked = true;
            target.dispatchEvent(new Event('change', { bubbles: true }));
          }
          updateSoon();
        });
      });

      // Delegated: survives the theme replacing the fieldset on re-render
      scope.addEventListener('change', function (e) {
        if (e.target && e.target.classList && e.target.classList.contains('js-option')) updateSoon();
      });
      document.addEventListener('on:variant:change', updateSoon);
      update();
    });
  }

  /* ---- Add-on modals ---- */
  function initAddons() {
    document.querySelectorAll('[data-df-addon]').forEach(function (card) {
      if (card.dataset.dfInit) return;
      card.dataset.dfInit = '1';

      var more = card.querySelector('[data-df-addon-more]');
      var modal = card.querySelector('[data-df-addon-modal]');
      var overlay = card.querySelector('[data-df-addon-overlay]');
      var close = card.querySelector('[data-df-addon-close]');

      function openModal() {
        if (!modal) return;
        modal.hidden = false;
        if (overlay) overlay.hidden = false;
        document.body.classList.add('df-addon-modal-open');
      }
      function closeModal() {
        if (!modal) return;
        modal.hidden = true;
        if (overlay) overlay.hidden = true;
        document.body.classList.remove('df-addon-modal-open');
      }

      if (more) more.addEventListener('click', openModal);
      if (close) close.addEventListener('click', closeModal);
      if (overlay) overlay.addEventListener('click', closeModal);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeModal();
      });
    });
  }

  /* ---- Add checked add-ons to the basket after the main product ---- */
  var addingAddons = false;
  document.addEventListener('on:cart:add', function () {
    if (addingAddons) return;

    var checks = document.querySelectorAll('.df-addon__check:checked');
    if (!checks.length) return;

    var items = [];
    checks.forEach(function (c) {
      var id = parseInt(c.dataset.dfAddonVariant, 10);
      if (id) items.push({ id: id, quantity: 1 });
    });
    if (!items.length) return;

    addingAddons = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add-on add failed: ' + r.status);
        return r.json();
      })
      .then(function () {
        checks.forEach(function (c) {
          c.checked = false;
        });
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      })
      .catch(function (e) {
        console.warn('[DF bespoke bed] ' + e.message);
      })
      .finally(function () {
        addingAddons = false;
      });
  });

  function initAll() {
    initSwatches();
    initFabricLibrary();
    initSize();
    initStorage();
    initAddons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after theme editor section reloads
  document.addEventListener('shopify:section:load', initAll);
})();
